import { render, staticRenderFns } from "./PromotionRewardsPage.vue?vue&type=template&id=0d6a7b9a&"
import script from "./PromotionRewardsPage.vue?vue&type=script&lang=js&"
export * from "./PromotionRewardsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports